import { ROLE_OPTIONS } from '../data';
import { cn } from '@/lib/utils';

export function RoleSelector({ value, onChange }) {
  return (
    <div className="px-5 py-6 sm:px-8 sm:py-7">
      <div
        role="radiogroup"
        aria-label="Role"
        className="grid gap-3 sm:grid-cols-2"
      >
        {ROLE_OPTIONS.map((opt) => {
          const Icon = opt.icon;
          const active = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => onChange(opt.value)}
              className={cn(
                'flex cursor-pointer items-start gap-3 rounded-2xl border-2 p-5 text-left transition-all',
                active
                  ? 'border-brand-600 bg-brand-50 shadow-md ring-2 ring-brand-200'
                  : 'border-slate-200 bg-white hover:border-brand-300 hover:bg-slate-50'
              )}
            >
              <div
                className={cn(
                  'flex size-11 shrink-0 items-center justify-center rounded-xl',
                  active
                    ? 'bg-brand-600 text-white'
                    : 'bg-slate-100 text-slate-600'
                )}
              >
                <Icon className="size-5" aria-hidden="true" />
              </div>
              <div>
                <p className="font-bold text-slate-900">{opt.label}</p>
                <p className="text-xs text-slate-600">{opt.description}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}